import { IconButton } from '@chegg-ui/button'
import { breakpoints, colors, spacing } from '@chegg-ui/theme'
import styled from 'styled-components'

export const CarouselContainer = styled.div<{ imageClickEnabled: boolean }>`
  position: relative;
  width: 100%;
  display: none;

  @media only screen and (min-width: ${breakpoints.lg.min}) {
    display: block;
    cursor: ${({ imageClickEnabled }) => (imageClickEnabled ? 'pointer' : 'default')};
  }
`

const ArrowButton = styled(IconButton)`
  position: absolute;
  top: calc(50% - ${spacing.px24}); // minus half of the button height
  background-color: ${colors.grey900};

  &:active,
  &:hover {
    background: ${colors.grey900};
    box-shadow: unset;
  }
`

export const LeftArrowButton = styled(ArrowButton)`
  left: ${spacing.px24};
`

export const RightArrowButton = styled(ArrowButton)`
  right: ${spacing.px24};
`

/** Not lazy laoding above the fold Image */
export const CarouselImage = styled.img`
  width: 100%;
  max-height: 100%;
`
